import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function DatePickerPopup({
  isOpen,
  onClose,
  onConfirm,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg">
        <h2 className="text-xl mb-4">Select Custom Date Range</h2>
        <div className="flex space-x-4">
          <div>
            <label className="block mb-2">Start Date</label>
            <DatePicker
              selected={startDate}
              onChange={(date) => {
                onStartDateChange(date);
                if (date > endDate) {
                  onEndDateChange(date);
                }
              }}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              maxDate={endDate}
              dateFormat="yyyy-MM-dd"
              inline
            />
          </div>
          <div>
            <label className="block mb-2">End Date</label>
            <DatePicker
              selected={endDate}
              onChange={(date) => {
                onEndDateChange(date);
                if (date < startDate) {
                  onStartDateChange(date);
                }
              }}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate}
              dateFormat="yyyy-MM-dd"
              inline
            />
          </div>
        </div>
        <div className="mt-4 flex justify-end space-x-2">
          <button
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-500"
            onClick={() => {
              if (endDate >= startDate) {
                onConfirm(startDate, endDate);
              } else {
                alert("End date cannot be earlier than start date.");
              }
            }}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}

export default DatePickerPopup;